globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};
import { jsx as _jsx } from "react/jsx-runtime";
export var RestworldBlackIcon = function RestworldBlackIcon() {
  return /*#__PURE__*/_jsx("svg", {
    width: "20",
    height: "18",
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      d: "M19.6607 4.98828C19.2498 4.58953 18.6121 4.57495 18.1822 4.9591C17.0391 5.98999 14.8567 8.39703 12.972 13.002C12.972 13.002 11.7816 11.232 10.1473 9.95796C10.1473 9.95796 15.4425 4.04977 10.544 0.78204C6.52892 -0.851827 5.0268 5.14388 5.38107 7.32237C5.38107 7.32237 0.0858434 6.91391 -0.00390625 10.6825C-0.00390625 13.1819 4.5875 12.8172 5.77786 12.4525C5.77786 12.4525 5.93846 14.0669 6.09435 15.3167C6.17465 15.9488 6.76983 16.367 7.36974 16.2114C7.9224 16.0704 8.25778 15.5014 8.12552 14.9325C7.93185 14.1107 7.69094 12.9145 7.58702 11.7717C7.58702 11.7717 8.3806 11.4994 8.77739 11.2271C8.77739 11.2271 11.5596 14.135 13.6758 17.4951C14.6395 13.7752 16.5856 9.4571 19.6182 6.65618C20.1 6.20881 20.1236 5.44051 19.6513 4.98341L19.6607 4.98828ZM2.03199 10.2303C1.80998 8.5964 5.34328 9.27718 5.34328 9.27718L5.5653 10.4588C5.5653 10.4588 2.25401 11.869 2.03672 10.2303H2.03199ZM7.15245 7.82323C7.19496 7.0063 7.72401 1.50658 10.0055 2.64445C12.2871 3.78233 8.78684 8.68879 8.78684 8.68879C8.78684 8.68879 8.25778 8.23656 7.15245 7.82323Z",
      fill: "#1C1327"
    })
  });
};